const MIN_LIMIT = 9;
const MAX_LIMIT = 20;

export function cleanVatNumber(value) {
  return value
    .replace(/[.|,|-]/g, "")
    .replace(/\s/g, "")
    .trim();
}

export function validateVatNumber(value) {
  // not empty string value
  if (!value || typeof value !== "string") {
    return false;
  }

  // starts with at least 2 letters
  if (/^[a-zA-Z]{2}/.test(value) === false) {
    return false;
  }

  // contain at least 7 digits
  if (/\d{7}/.test(value) === false) {
    return false;
  }

  // min and max characters
  if (value.length < MIN_LIMIT || value.length > MAX_LIMIT) {
    return false;
  }

  return true;
}
